module.exports = __webpack_public_path__ + "assets/img/02fe8f3ce28bfb43364ca805ce5ccce7.png";